import { render, staticRenderFns } from "./UserViewUserInfoCard.vue?vue&type=template&id=30b3ecf0&scoped=true&"
import script from "./UserViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./UserViewUserInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./UserViewUserInfoCard.vue?vue&type=style&index=0&id=30b3ecf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b3ecf0",
  null
  
)

export default component.exports